module.exports = __webpack_public_path__ + "img/close.40477f48.svg";